import React from 'react';
import { Box, Typography, Container } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#f9fafb',
        py: 6,
        mt: 'auto',
        borderTop: '1px solid #e5e7eb',
        textAlign: 'center',
      }}
    >
      <Container maxWidth="lg">
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '1rem' }}>
          © {new Date().getFullYear()} ERP Escritórios Arquitetura. Todos os direitos reservados.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
